<template>
  <div>
    <div class="document">
      <!-- <img src="../../../assets/img/logo/NAN_logomark_RGB_Evergreen.png" alt="" class="center" style="width: 110px; padding-bottom: 10px;"> -->
      <h3 style="text-align: center;">Consent and Authorization – Transport of Child(ren) with Employee Vehicle(s)</h3>
      <hr>
      <p>Client Name(s): {{ document.field1 }} (hereinafter, the “Client”)</p>
      <pre v-html="document.body"></pre>
      <hr>
      <p style="font-weight: 600; margin-bottom: 0;">Client</p>
      <p v-if="document.status == 'Unsigned'">{{ new Date().toDateString() }}</p>
      <p v-if="document.status == 'Signed'">{{ new Date(document.signing_date).toDateString() }}</p>
      <h4 v-if="signature" style="font-family: 'Arizonia'">{{ signature }}</h4>
      <h4 v-if="!signature">___________</h4>
      <p v-if="document.status == 'Signed'">{{ document.signing_name }}</p>
      <div v-if="!document.signing_name">
        <input type="text" class="form-control" v-model="signature" style="max-width: 500px;">
        <label class="mt-1">Signature of the Client (Please Type)</label>
        <div>
          <button v-if="!signature" class="mylisting-button disabled-button mt-3" style="cursor: not-allowed; color: gray;" @click.prevent="">Sign</button>
          <button v-if="signature" class="mylisting-button dark-button mt-3" @click="sign()">Sign</button>
        </div>
      </div>

      <p style="font-weight: 600; margin-top: 25px; margin-bottom: 0;">The Nanny Company</p>
      <p>{{ new Date(document.signing_date_secondary).toDateString() }}</p>
      <h4 v-if="document.signing_name_secondary" style="font-family: 'Arizonia'">{{ document.signing_name_secondary }}</h4>
      <p>Per: {{ document.signing_name_secondary }}</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['document'],
  data() {
    return {
      signature: '',
    }
  },
  created() {
    this.signature = this.document.signing_name
  },
  methods: {
    sign() {
      axios.patch(`/api/documents/${this.document.id}/`, {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed',
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employers/documents/TransportChildrenEmployeeVehicle.vue